import { useTranslation } from "react-i18next";
import CommonBanner from "../component/Common/CommonBanner";
import FlightSearchArea from "../component/FlightSearch";
import Seo from "component/Common/seo";

const FlightSearch = () => {
    const { t } = useTranslation();
    return (
        <>
            <Seo
                title="Recherche de Vols | Je Voyage Ici"
                description="Comparez les meilleurs vols nationaux et internationaux et réservez votre billet d'avion en toute sécurité."
                canonical="/flight-search"
                image="/images/preview-bg.png"
            />
            <CommonBanner
                heading={t("flightsSearchResult")}
                pagination="Flight search result"
            />
            <FlightSearchArea />
        </>
    );
};

export default FlightSearch;